import React from 'react';

import MIconButton from 'material-ui/IconButton';

const IconButton = ({ children, ...props }) => {
  return <MIconButton {...props}>{children}</MIconButton>;
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/basic/IconButton.js